import axios from "axios";

const baseURL = process.env.REACT_APP_BASEURL;

const api = process.env.REACT_APP_API;

// Service for Coordinates by location name

export function getLocationName(data) {
  return axios.get(
    `${baseURL}data/2.5/find?q=${data.location}&appid=${api}&units=metric`
  );
}

// Service for Current Coordinates weather

export function getCurrentLocationWeather(data) {
  return axios.get(
    `${baseURL}data/2.5/onecall?lat=${data.latitude}&lon=${data.longitude}&units=metric&appid=${api}`
  );
}

export function getSearchCurrentLocationWeather(data) {
  return axios.get(
    `${baseURL}data/2.5/onecall?lat=${data.lat}&lon=${data.lon}&units=metric&appid=${api}`
  );
}
